define([
	"dojo/_base/declare",
	"dojo/topic",
	"csi/action/NewController",
	"csi/session",
	"csi/state/rootStore",
	"csi/xml"
], function(declare, topic, NewController, session, { routerStore, sessionStore }, xml) {

	return declare(NewController, {

		constructor: function(/*Object*/params) {
			this.m_urlParent = sessionStore.currentUser.Preferences;
			this.m_idAttrParent = "Favorites";
		},

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for season to the parent season and make it read only
			view.addDefaultValue("Description", routerStore.locationDescription);
			this.inherited(arguments);
		},

		toWriter: function() {
			// summary: save link to favorite item and location hash
			var params = session.getLocationParams();
			var url = params[session.LOCATION_URL];
			delete params[session.LOCATION_URL];
			var hash = session.getLocation(null, params);

			this.inherited(arguments);

			this.m_cnNew.changeAttribute("__FavoriteItem__", xml.ATTR_REF, url);
			this.m_cnNew.changeAttribute("Location", xml.ATTR_STRING, hash);

			// Administrator does not have Favorites link, so make sure to add it if not there
			if (!xml.nodeHasAttribute(this.getParent(), this.m_idAttrParent)) {
				this.m_writer.changeNode(this.m_urlParent).addAttribute(this.m_idAttrParent, xml.ATTR_REFLIST, []);
			}
		},

		postProcessSuccess: function() {
			topic.publish("/csi/pageHeader/refresh");
			topic.publish("/csi/favoriteTable/refresh");
		},

		_canRepeat: function() {
			// summary: disallow Save & New in this case
			return false;
		}
	});
});